module.exports = __webpack_public_path__ + "img/p1-desc@2x.8c69ef54.jpg";